import { composeContainers } from "@/utils/composeContainers";
import { withActions } from "../../../../containers/withActions";
import { PopupModal } from "../../../PopupModal/PopupModal";
import { PopupList } from "./components/PopupList/PopupList";
import { ContainerProps, ViewProps } from "./types";

export default composeContainers<ViewProps, ContainerProps>({
  containers: [withActions],
  component: ({ ...props }) => (
    <>
      <PopupList {...props} />

      <PopupModal {...props} />
    </>
  ),
});
